// client/src/components/shell/PfAppTopBar.js
// App-level top bar. Distinct from PfTopBar (which is team-scoped chrome
// with team name / tier / role pill). This one is the org-scoped identity
// bar for app-level routes (/, /teams, /whoami) — hamburger left,
// org identity centered, nothing on the right (reserved for future:
// notifications bell, avatar, etc.).

import { useOrg } from '../../lib/OrgProvider';

export function PfAppTopBar({ onMenuClick }) {
  const { activeOrg } = useOrg();

  // /me exposes the active membership as { org_id, org_name, role, ... }.
  // If the field name here is wrong at runtime, check whoami — the
  // membership shape is what drives display.
  const orgName = activeOrg?.org_name || '';
  const orgLogoUrl = activeOrg?.org_logo_url || null;

  return (
    <header
      className="
        sticky top-0 z-30
        h-14 px-3
        flex items-center justify-between
        bg-white/95 backdrop-blur
        border-b border-ink/10
      "
    >
      {/* Hamburger — left */}
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Open menu"
        className="
          h-10 w-10 -ml-1
          flex items-center justify-center
          rounded-full
          active:bg-ink/5
        "
      >
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M3 6.5 Q11 5.8 19 6.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M3 11 Q11 10.6 19 11.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M3 15.5 Q11 15 19 15.8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>

      {/* Org identity — centered */}
      <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 pointer-events-none">
        {orgLogoUrl ? (
          <img src={orgLogoUrl} alt="" className="h-7 w-7 rounded-full object-cover" />
        ) : (
          <div className="h-7 w-7 rounded-full bg-ink/10" />
        )}
        <span className="font-serif text-lg text-ink truncate max-w-[200px]">
          {orgName}
        </span>
      </div>

      {/* Right — reserved for future affordances */}
      <div className="h-10 w-10" aria-hidden />
    </header>
  );
}